<template>
	<div class="home">
		<h1>Loyalty Program Store Checkout Demo</h1>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: "Home",
};
</script>
